import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';

import {createForm, renderModalError} from '@utils/forms';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import MediaConnectModel from '@modules/mediaConnect/forms/MediaConnectModel';
import MediaConnectEditButtons from '@modules/mediaConnect/components/MediaConnectEditButtons';
import MediaConnectForm from '@modules/mediaConnect/forms/MediaConnectForm';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {showModal} from '@utils/modal';
import {routes} from '@constants/routes';

export const MediaConnectEdit = ({
    match: {
        params: {id = null},
    },
}) => {
    const [pageTitle, setPageTitle] = React.useState('MediaConnect origin entry point');

    let buttonProps = {name: 'mediaConnect.index'};

    if (!isUrlParamValid(id)) {
        showModal({
            isVisible: true,
            content: renderModalError('Mediaconnect Origin Entry Point', routes.mediaConnect.index.path),
        });
    }

    const Form = React.useMemo(() => (
        createForm(
            MediaConnectModel,
            MediaConnectForm, {
                id: convertToInt(id),
                setPageTitle: setPageTitle,
                entityFetchPolicy: 'no-cache',
            }
        )
    ), []);

    return (
        <div>
            <HeaderRenderer
                buttons={MediaConnectEditButtons}
                buttonsProps={buttonProps}
                messagesBoxNames='mediaConnectMessageError'
                pageTitle={pageTitle}
            />
            <Form/>
        </div>
    );
};
MediaConnectEdit.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }).isRequired,
};

MediaConnectEdit.displayName = 'MediaConnectEdit';

export default withRouter(MediaConnectEdit);
